export default "__VITE_ASSET__CQeBvxtW__"